import { USER_SETTINGS_FORM } from './form-user-settings-types';

import GetSettingsUser from './get-user-settings';
import UpdateUserSettings from './update-user-settings';

/**
 * Handles the user settings form
 * 
 * @returns void
 */
export const formUserSettings = () => {
  if ( !USER_SETTINGS_FORM.settingForm)  return;

  GetSettingsUser();
  UpdateUserSettings();
}